








































































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { errorMessage } from '../store/types';

@Component({
  name: 'ChangePassword',
})
export default class ChangePassword extends Vue {
  @Ref() readonly changePasswordForm!: HTMLFormElement;

  @Action('auth/changePassword') changePasswordAct!: () => Promise<any>;
  @Mutation('auth/setToken') setToken!: (token: string) => void;
  @Mutation('auth/setNewPassword') setNewPassword!: (
    newPassword: string
  ) => void;
  @Mutation('auth/setConfirmNewPassword') setConfirmNewPassword!: (
    confirm: string
  ) => void;
  @Getter('auth/getNewPassword') getNewPassword!: () => string;
  @Getter('auth/getConfirmNewPassword') getConfirmNewPassword!: () => string;
  @Getter('auth/validator') validator!: () => Vue;
  @Getter('org/getShortName') getShortName!: () => string;

  errorMessage = '';
  submiting = false;
  success = false;
  showPasswordSt = false;
  showPasswordNd = false;

  created() {
    if (this.$route.params.token) this.setToken(this.$route.params.token);
  }

  logIn() {
    this['$router'].push(`/${this.getShortName}`);
  }

  changePassword(formValidity: boolean) {
    if (formValidity) {
      this.changePasswordForm.validate();
      return;
    }

    this.submiting = true;

    this.changePasswordAct()
      .then(() => {
        this.submiting = false;
        this.success = true;
      })
      .catch((error: errorMessage) => {
        this.submiting = false;
        this.errorMessage = error.message;
      });
  }
}
